import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';
import { AllegatiArticoliService } from 'src/app/shared/services/allegati-articoli.service';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';
import { confirm } from 'devextreme/ui/dialog';
import { ConvertError } from 'src/app/utils/gestione-errori';
import { TAB_ALLEGATI_ARTICOLI } from 'src/app/consts/const';
import { DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';
import { DxButtonComponent, DxFileUploaderComponent, DxTextBoxComponent, DxValidatorComponent } from 'devextreme-angular';

@Component({
  selector: 'app-form-allegato',
  templateUrl: './form-allegato.component.html',
  styleUrls: ['./form-allegato.component.scss'],
  imports: [
    DxButtonComponent,
    DxFileUploaderComponent,
    DxTextBoxComponent,
    DxValidatorComponent,
    DxiValidationRuleComponent
  ],
  standalone: true
})
export class FormAllegatoComponent extends GestArticoliBaseComponent {
  private allegatiArticoliService= inject(AllegatiArticoliService);

  @Input() idRecord;
  @Input() tabellaRif;
  @Output() formNewAllegatoEventEmitter = new EventEmitter<boolean>();

  nomeAllegato: string = '';
  value = [];

  allegaFile(e, files) {
    if (this.idRecord) {
      const result = e.validationGroup.validate();
      if (result.isValid) {
        const result = confirm('<i>Procedere con il caricamento del nuovo allegato?</i>', 'Nuovo allegato');
        result.then((dialogResult) => {
          if (dialogResult) {

            const formData = new FormData();
            formData.append('file', files[0]);
            if (this.tabellaRif == TAB_ALLEGATI_ARTICOLI) {
              this.newAllegatoArticolo(formData);
            }
            else {
              //TODO
              // PRevedere la gestione anche per le altre tabelle degli allegati
            }
          }
        });

      }
    }
  }

  clearForm() {
    this.value = [];
  }

  newAllegatoArticolo(formData: any) {
    this.allegatiArticoliService.allega(this.idRecord, this.nomeAllegato, formData).subscribe({
      next: () => {
        notificaMessaggio('Allegato salvato', 'success');
        this.clearForm();
        this.formNewAllegatoEventEmitter.next(true);
      },
      error: (error) => {
        ConvertError(error, 'Errore caricamento nuovo allegato');
      }
    });
  }
}

